import BaseClient from '@/app/model/api/response/baseApiClient'

class NewsBoardEditApi extends BaseClient {
  public doNewsBoardEdit (id: string, bodyData: any) {
    const path:string = '/v1/news-boards/' + id

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new NewsBoardEditApi()
